// Libraries
window.jQuery = window.jquery = window.$ = require('jquery');
window.bootstrap = require('bootstrap');
window.DataTable = window.datatable = require('datatables.net-bs');

window.datepicker = require('bootstrap-datepicker');
window.moment = require('moment');
window.timepicker = require('timepicker');
window.fullCalendar = require('fullcalendar');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.select2 = require('select2');
window.mask = require('jquery-mask-plugin');